/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { Nav } from "./Navbar";
import { MovingBorderButton } from "./Button";
import { useNavigate } from "react-router-dom";
import { ChatContext } from "../contexts/ChatContext";
import HomeParticle from "./Particle/HomeParticle";
import ApkBanner from "./ApkBanner";

const HomePage = () => {
  const [showButtons, setShowButtons] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const {sessionId,startNewSession}=useContext(ChatContext)
  const [robotPosition, setRobotPosition] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const {loadChatHistory} = useContext(ChatContext)
  const user_id = localStorage.getItem("user_id");
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/chat");
    window.location.reload();
  };

  if(!navigator.cookieEnabled){
    navigator.cookieEnabled();
  }

  const handleVoiceClick = () => {
    navigate("/call");
  };

  const handleMouseMove = (e) => {
    if (!hoveredButton) {
      const buttonRect = e.target.getBoundingClientRect();
      const x = (buttonRect.left + buttonRect.right) / 2;
      const y = (buttonRect.top + buttonRect.bottom) / 2;
      setRobotPosition({ x, y });

      const angle =
        Math.atan2(y - window.innerHeight / 2, x - window.innerWidth / 2) *
        (360 / Math.PI);
      setRotation(angle);

      if (x < window.innerWidth / 2) {
        setFlipped(true);
      } else {
        setFlipped(false);
      }
    }
  };

  const resetRobotPosition = () => {
    setRobotPosition({ x: 0, y: 0 });
    setRotation(0);
    setFlipped(false);
    setHoveredButton(null);
  };

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobileScreen(window.innerWidth <= 640);
    };

    checkScreenWidth();
    window.addEventListener("resize", checkScreenWidth);

    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
  }, []);

  const handleButtonHover = (text) => {
    setHoveredButton(text);
  };

  const toggleButtons = () => {
    setShowButtons(!showButtons);
  };
  useEffect(() => {
    loadChatHistory(user_id);
  }, []);

  useEffect(() => {
    if (sessionId === null || !sessionId) {
      startNewSession();
    }
  }, [sessionId]);

  return (
    <>
      <div
        className="relative w-full h-screen bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/bg.jpg')" }}
      >
        <Nav />
        <ApkBanner/>
         <HomeParticle /> 
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center space-y-4">
          <h1 className="absolute top-20 w-full text-center text-2xl md:text-4xl lg:text-4xl font-bold text-white whitespace-pre-wrap">
            {hoveredButton || "Got a question?"} <br />
            {hoveredButton
              ? `Let's ${hoveredButton.toLowerCase()}.`
              : "We've got the answer."}
          </h1>
  
          {isMobileScreen && (
            <>
              <div
                className="relative w-1/2 md:w-1/2 lg:w-1/4 flex justify-center transition-transform"
                style={{
                  transform: `translate(${robotPosition.x / 20}px, ${
                    robotPosition.y / 20
                  }px) rotate(${rotation}deg) ${
                    flipped ? "scaleX(-1)" : "scaleX(1)"
                  }`,
                  transition: "transform 0.5s ease",
                }}
                onClick={toggleButtons}
              >
                <img
                  src="/robot.png"
                  alt="Robot"
                  className="h-56 md:max-h-56 lg:max-h-60 xl:max-h-[100%] xl:max-w-[100%] w-48 md:max-w-full floating"
                />
                 <button
                  className="absolute top-1/4 left-1/2 transform -translate-x-1/3 -translate-y-1/2 text-white text-xl md:text-xl lg:text-2xl font-bold bg-transparent animate-pulse"
                  onClick={toggleButtons}
                >
                  Tap Me!
                </button>
              </div>
              {showButtons && (
                <div className="absolute inset-0 flex flex-col items-center justify-center backdrop-blur-xl space-y-4">
                  <button
                    className="absolute top-16 right-5"
                    onClick={toggleButtons}
                  >
                    <img
                      src="https://img.icons8.com/?size=100&id=pHtKLuytfhLc&format=png&color=FFFFFF"
                      alt="sidebar"
                      className="h-8 w-8"
                    />
                  </button>
                  <div
                    onMouseEnter={() => handleButtonHover("Video Call")}
                    onMouseLeave={() => handleButtonHover(null)}
                    onMouseMove={handleMouseMove}
                    onMouseOut={resetRobotPosition}
                    onClick={() => navigate("/videoCall")}
                  >
                    <MovingBorderButton className="h-14 md:h-16 lg:h-16 text-white font-medium rounded-full px-6 py-2 mt-8">
                      Video Call
                    </MovingBorderButton>
                  </div>
                  <div
                    onMouseEnter={() => handleButtonHover("Voice Call")}
                    onMouseLeave={() => handleButtonHover(null)}
                    onMouseMove={handleMouseMove}
                    onMouseOut={resetRobotPosition}
                    onClick={handleVoiceClick}
                  >
                    <MovingBorderButton className="h-14 md:h-16 lg:h-16 text-white font-medium rounded-full px-6 py-2 mt-8">
                      Voice Call
                    </MovingBorderButton>
                  </div>
                  <div
                    onMouseEnter={() => handleButtonHover("Chat")}
                    onMouseLeave={() => handleButtonHover(null)}
                    onMouseMove={handleMouseMove}
                    onMouseOut={resetRobotPosition}
                    onClick={handleClick}
                  >
                    <MovingBorderButton className="h-14 md:h-16 lg:h-16 text-white font-medium rounded-full px-11 py-2 mt-8">
                      Chat
                    </MovingBorderButton>
                  </div>
                  <div
                    onClick={() => navigate('/itinerary')}
                    onMouseEnter={() => handleButtonHover("Get Itinerary")}
                    onMouseLeave={() => handleButtonHover(null)}
                    onMouseMove={handleMouseMove}
                    onMouseOut={resetRobotPosition}
                  >
                    <MovingBorderButton className="h-14 md:h-16 lg:h-16 text-white font-medium rounded-full px-6 py-2 mt-8">
                      Get Itinerary
                    </MovingBorderButton>
                  </div>
                </div>
              )}
            </>
          )}
          {!isMobileScreen && (
            <div className="flex flex-col items-center justify-center">
              <div
                className="relative lg:w-72 flex justify-center transition-transform"
                style={{
                  transform: `translate(${robotPosition.x / 20}px, ${
                    robotPosition.y / 20
                  }px) rotate(${rotation}deg) ${
                    flipped ? "scaleX(-1)" : "scaleX(1)"
                  }`,
                  transition: "transform 0.5s ease",
                }}
              >
                <img
                  src="/robot.png"
                  alt="Robot"
                  className="h-56 md:h-56 lg:h-60 lg:w-48 xl:h-[320px] xl:w-[290px] w-60 md:w-full floating"
                />
              </div>
              <div className="absolute left-0 top-1/4 flex flex-col space-y-16 transform translate-x-2 md:translate-x-4 lg:translate-x-24 xl:translate-x-48 mt-8">
                <div
                  onMouseEnter={() => handleButtonHover("Video Call")}
                  onMouseLeave={() => handleButtonHover(null)}
                  onMouseMove={handleMouseMove}
                  onMouseOut={resetRobotPosition}
                  onClick={() => navigate("/videoCall")}
                >
                  <MovingBorderButton className="relative inline-flex h-14 md:h-16 lg:h-16 overflow-hidden rounded-full p-[1px] focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50">
                    Video Call
                  </MovingBorderButton>
                </div>
                <div
                  onMouseEnter={() => handleButtonHover("Voice Call")}
                  onMouseLeave={() => handleButtonHover(null)}
                  onMouseMove={handleMouseMove}
                  onMouseOut={resetRobotPosition}
                  onClick={handleVoiceClick}
                >
                  <MovingBorderButton className="px-12 py-2 md:px-20 md:py-2 border-2 border-black dark:border-white uppercase bg-white text-black transition duration-200 text-base md:text-lg lg:text-xl shadow-[1px_1px_rgba(0,0,0),2px_2px_rgba(0,0,0),3px_3px_rgba(0,0,0),4px_4px_rgba(0,0,0),5px_5px_0px_0px_rgba(0,0,0)] dark:shadow-[1px_1px_rgba(255,255,255),2px_2px_rgba(255,255,255),3px_3px_rgba(255,255,255),4px_4px_rgba(255,255,255),5px_5px_0px_0px_rgba(255,255,255)] mt-8">
                    Voice Call
                  </MovingBorderButton>
                </div>
              </div>
              <div className="absolute right-0 top-1/4 flex flex-col space-y-16 transform -translate-x-2 md:-translate-x-8 lg:-translate-x-32 xl:-translate-x-64 mt-8">
                <div
                  onMouseEnter={() => handleButtonHover("Chat")}
                  onMouseLeave={() => handleButtonHover(null)}
                  onMouseMove={handleMouseMove}
                  onMouseOut={resetRobotPosition}
                  onClick={handleClick}
                >
                  <MovingBorderButton className="relative inline-flex h-14 md:h-16 lg:h-16 overflow-hidden rounded-full p-[1px] focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50">
                    Chat
                  </MovingBorderButton>
                </div>
                <div
                  onClick={() => navigate('/itinerary')}
                  onMouseEnter={() => handleButtonHover("Get Itinerary")}
                  onMouseLeave={() => handleButtonHover(null)}
                  onMouseMove={handleMouseMove}
                  onMouseOut={resetRobotPosition}
                >
                  <MovingBorderButton className="relative inline-flex h-14 md:h-16 lg:h-16 overflow-hidden rounded-full p-[1px] focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-slate-50">
                    Get Itinerary
                  </MovingBorderButton>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
  
};

export default HomePage;
